import * as t from 'io-ts';

import { OnboardingStepsEnum } from '../../../src/modules/partner/model/onboarding';

/** `{ field: [messages] }` or a list of `{ attribute, type }`; read in the app. */
const StepErrors = t.unknown;

const Onboarding = t.type({
  completed: t.boolean,
  last_step_name: t.keyof(OnboardingStepsEnum),
  last_step_completed: t.boolean,
});

type TOnboarding = t.TypeOf<typeof Onboarding>;

export { StepErrors, Onboarding };
export type { TOnboarding };
